import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper } from '@offerzen/pinata'

const styles = {
  overlay: css({
    position: 'fixed',
    top: 62, // offset navigation height
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 600, // zIndex is set high to avoid conflicts with pinata components
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    perspective: '600px',
    overflowY: 'hidden',
    maxHeight: 'calc(100vh - 62px)',
  }),

  fader: css({
    backgroundColor: 'rgba(19, 31, 74, 0.5)',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 0,
  }),

  noScroll: css({
    overflow: 'hidden',
  }),

  content: css({
    height: '100%',
    maxHeight: 'calc(100vh - 62px)',
    overflowY: 'auto',

    [mediaQueryHelper(breakpoint.phone)]: {
      height: 'auto',
    },
  }),
}

export default styles
